export const protocolsMAMMOGRAPHY = ["Здесь будут протоколы мамы"];
